import { useCallback } from "react"

import settings from "../lib/settings"
import { useActiveProfileId } from "./use-active-profile-id"
import { SettingHookReturn, useSetting } from "./use-setting"

const AUTOPLAY_VIDEOS_SETTING_KEY = "autoplay-videos"

export function useAutoplayVideosSetting(): SettingHookReturn<boolean> {
  const profileId = useActiveProfileId()
  const [setting, setSetting] = useSetting<boolean>({
    key: AUTOPLAY_VIDEOS_SETTING_KEY,
    settings,
    strategy: "local",
    profileId,
    defaultValue: true,
  })
  const setAutoplayVideos = useCallback(
    (value: boolean | undefined) => setSetting(Boolean(value)),
    [setSetting],
  )
  return [setting, setAutoplayVideos]
}
